/* eslint-env browser, jquery */
import page from 'modules/ab-page-js';
import domify from 'domify';
import container from 'modules/section-content';
import splash from './partners-page.pug';
import metadata from './metadata.json';

export default function register() {
  page('/partners', render, snippets);
}

function render(ctx, next) {
  const renderOptions = {
    metadata,
    // Only pass view on client render.
    ...(ctx.init ? {} : { view: domify(splash()) })
  };
  container.render(renderOptions);

  next();
}

function snippets(ctx, next) {
  // "Go to" script
  $('a[data-go-to]').click(function() {
    if (
      location.pathname.replace(/^\//, '') === this.pathname.replace(/^\//, '') ||
      location.hostname === this.hostname
    ) {
      let target = $(this.hash);
      target = target.length ? target : $(`[name=${this.hash.slice(1)}]`);
      if (target.length) {
        $('html,body').animate(
          {
            scrollTop: target.offset().top
          },
          1000
        );
        return false;
      }
    }
  });

  // Show on scroll
  const $animation_elements = $('.item .images');
  const $animation_elements_span = $('#ico > span');
  const $window = $(window);

  function check_if_in_view() {
    const window_height = $window.height();
    const window_top_position = $window.scrollTop();
    const window_bottom_position = window_top_position + window_height;

    $.each($animation_elements_span, function() {
      const $element = $(this);
      const element_height = $element.outerHeight();
      const element_top_position = $element.offset().top;
      const element_bottom_position = element_top_position + element_height;

      // check to see if this current container is within viewport
      if (
        element_bottom_position >= window_top_position &&
        element_top_position <= window_bottom_position
      ) {
        $element.addClass('animate');
      }
    });

    $.each($animation_elements, function() {
      const $element = $(this);
      const element_height = $element.outerHeight();
      const element_top_position = $element.offset().top;
      const element_bottom_position = element_top_position + element_height;

      // check to see if this current container is within viewport
      if (
        element_bottom_position >= window_top_position &&
        element_top_position <= window_bottom_position
      ) {
        $element.addClass('animate');
      }
    });
  }

  $window.on('scroll resize', check_if_in_view);
  $window.trigger('scroll');

  // Form stuff
  $('a[data-toggle="tab"]').on('shown.bs.tab', () => {
    $('.tab-pane').removeClass('animated');
    $('.tab-pane.active').addClass('animated');
  });

  $('.section-form form').on('submit', function(e) {
    e.preventDefault();

    const $currentForm = $(this);
    const $submitBtn = $(this).find('button[type="submit"]');
    const formData = getFormData();

    function setButtonToSend() {
      $submitBtn.data('orig-text', $submitBtn.text());

      $submitBtn.attr('disabled', 'disabled');
      $submitBtn.text('Sending...');
    }

    function isValidEmail(val) {
      if (/^([a-zA-Z0-9_\.\-])+\@(([a-zA-Z0-9\-])+\.)+([a-zA-Z0-9]{2,4})+$/.test(val)) {
        return true;
      }
      return false;
    }

    function getFormData() {
      let str = '';
      const email = $currentForm.find('input[name="email"]').val();

      if (!isValidEmail(email)) {
        return alert('Please enter a valid email');
      }

      setButtonToSend();

      $currentForm.find('input, textarea').each(function() {
        const val = $(this).val();

        if (val && $(this).attr('name')) {
          str += `${$(this).attr('name')}: ${val}\n`;
        }
      });

      return str;
    }

    function sendForm() {
      $.ajax({
        type: 'POST',
        url: 'https://webtask.it.auth0.com/api/run/wt-victorhf-gmail_com-0/partner-to-slack?webtask_no_cache=1',
        data: JSON.stringify({
          data: {
            content: formData
          }
        }),
        processData: false,
        contentType: 'application/json',
        success() {
          onFormSent($submitBtn);
        },
        error() {
          $submitBtn.text($submitBtn.data('orig-text'));

          alert('There was a problem submitting your information. Please try again later.');
        }
      });
    }

    if (formData) {
      sendForm();
    }
  });

  function onFormSent($button) {
    $button.text('Thanks for getting in touch!');
    $button.addClass('success');
  }

  next();
}



// WEBPACK FOOTER //
// ./src/pages/partners/partners.js